module.exports = __webpack_public_path__ + "img/guzhen_bottom_coy.7993b269.jpg";